import { ref } from "vue";
import { defineStore } from "pinia";
export const useModalsStore = defineStore('modals', {
  // arrow function recommended for full type inference
  state: () => {
    return {
      modals: {
        loadingstatus: {
          show: false
        },
        companyinfo: {
          show: false,
          data: {},
          modus: '' // new, edit
        },
        editevent: {
          show: false,
          data: {},
          times: {}
        },
        editequipment: {
          show: false,
          modus: '',
          kindofequipmentid: ''
        },
        editroom: {
          show: false,
          data: {}
        },
        editcontractoffering: {
          show: false,
          data: {},
          modus: ''
        },
        editimageratio: {
          show: false,
          data: [],
          standardratios: [],
          name: ''
        },
        editimage: {
          show: false,
          data: []
        },
        mediapreview: {
          show: false,
          data: []
        },
        mediabrowser: {
          show: false,
          settings: []
        },
        addcontract: {
          show: false,
          data: {},
          type: ''
        },
        editcontract: {
          show: false,
          data: {} as any,
          bookings: [] as any[]
        },
        duplicateevents: {
          show: false,
          date: [],
          rooms: []
        },
        newclient: {
          show: false
        },
        edittask: {
          show: false,
          modus: 'new',
          id: '',
        },
        editcompanyinfo: {
          show: false,
          type: '',
          dataobject: null
        },
        editstaff: {
          show: false,
          dataobject: null,
          tab: 'basic'
        },
        editopeninghours: {
          show: false,
          data: {}
        },
        editEventModal: {
          isOpen: false,
          eventData: null as any,
          loading: false,
          modalContracts: [] as any[],
          modalBookings: [] as any[]
        },
        schemaUpdate: {
          show: false,
          missingTables: [] as string[],
          serverVersion: 0,
          localVersion: 0,
          // ── Live state of the heal that runs after "Jetzt aktualisieren" ──
          // The modal stays open and mirrors these; without it the user saw
          // the dialog vanish while the DB was still being rebuilt.
          phase: 'confirm' as 'confirm' | 'running' | 'done' | 'error',
          steps: {
            patch: 'pending' as 'pending' | 'running' | 'done',
            recreate: 'pending' as 'pending' | 'running' | 'done',
            sync: 'pending' as 'pending' | 'running' | 'done'
          },
          stepMessages: { patch: '', recreate: '', sync: '' } as Record<string, string>,
          progress: {
            tablesLoaded: 0,
            tablesTotal: 0,
            records: 0,
            lastaction: ''
          },
          errorStep: '' as '' | 'patch' | 'recreate' | 'sync',
          error: ''
        }
      },
    }
  },
  actions: {
    modalloadingstatus(obj: { show: boolean }) {
      this.modals.loadingstatus.show = obj.show
    },
    modaleditevent(obj: { show: boolean; dataobject?: any; times?: any }) {
      this.modals.editevent.data = obj.dataobject
      this.modals.editevent.times = obj.times
      this.modals.editevent.show = obj.show
      if (obj.show === false) document.body.classList.remove('modal-open')
    },
    modaladdcontract(obj: { show: boolean; data?: any; type?: string }) {
      this.modals.addcontract.data = obj.data ?? {}
      this.modals.addcontract.show = obj.show
      this.modals.addcontract.type = obj.type ?? ''
      if (obj.show === false) {
        document.body.classList.remove('modal-open')
      } else {
        document.body.classList.add('modal-open')
      }
    },
    modaleditcontract(obj: { show: boolean; data?: any; bookings?: any[] }) {
      this.modals.editcontract.data = obj.data ?? {}
      this.modals.editcontract.show = obj.show
      this.modals.editcontract.bookings = obj.bookings ?? []
      if (obj.show === false) {
        document.body.classList.remove('modal-open')
      } else {
        document.body.classList.add('modal-open')
      }
    },
    modaleditroom(obj) {
      console.log(obj)
      this.modals.editroom.data = obj.dataobject
      this.modals.editroom.show = obj.show
      if (obj.show === false) {
        document.body.classList.remove('modal-open')
      } else {
        document.body.classList.add('modal-open')
      }
    },
    modaleditcontractoffering(obj: any) {
      console.log('modaleditcontractoffering')
      this.modals.editcontractoffering.data = obj.data
      this.modals.editcontractoffering.modus = obj.modus
      this.modals.editcontractoffering.show = obj.show
      if (obj.show === false) document.body.classList.remove('modal-open')
    },
    modaleditimageratio(obj: any) {
      console.log('modaleditimageratio')
      this.modals.editimageratio.data = obj.data
      this.modals.editimageratio.standardratios = obj.standardratios
      this.modals.editimageratio.name = obj.name
      this.modals.editimageratio.show = obj.show
      if (obj.show === false) document.body.classList.remove('modal-open')
    },
    modaleditimage(obj: any) {
      console.log('modaleditimage')
      this.modals.editimage.data = obj.data
      this.modals.editimage.show = obj.show
      if (obj.show === false) document.body.classList.remove('modal-open')
    },
    modalpreviewmedia(obj: any) {
      console.log('modalmediapreview')
      this.modals.mediapreview.data = obj.data
      this.modals.mediapreview.show = obj.show
      if (obj.show === false) document.body.classList.remove('modal-open')
    },
    modalmediabrowser(obj: any) {
      this.modals.mediabrowser.settings = obj.settings
      this.modals.mediabrowser.show = obj.show
      if (obj.show === false) document.body.classList.remove('modal-open')
    },
    modalduplicateevents(obj: any) {
      this.modals.duplicateevents.date = obj.date
      this.modals.duplicateevents.rooms = obj.rooms
      this.modals.duplicateevents.show = obj.show
      if (obj.show === false) document.body.classList.remove('modal-open')
    },
    modalnewclient() {
      this.modals.newclient.show = !this.modals.newclient.show
      if (this.modals.newclient.show === false) document.body.classList.remove('modal-open')
    },
    modaledittask(obj: any) {
      this.modals.edittask.modus = obj.modus
      this.modals.edittask.id = obj.id
      this.modals.edittask.show = obj.show
      if (obj.show === false) document.body.classList.remove('modal-open')
    },
    modalEditCompanyInfo(obj: { show: boolean; type?: string; dataobject?: any }) {
      this.modals.editcompanyinfo.type = obj.type || ''
      this.modals.editcompanyinfo.dataobject = obj.dataobject || null
      this.modals.editcompanyinfo.show = obj.show
      if (obj.show === false) {
        document.body.classList.remove('modal-open')
      } else {
        document.body.classList.add('modal-open')
      }
    },
    /** `tab` öffnet das Modal direkt auf einem Reiter ('basic' | 'acl') —
     *  gebraucht für „Einladen" aus der Mitarbeiterliste, das sonst auf den
     *  Basisdaten landet und den Zugangs-Block nicht zeigt. */
    modalEditStaff(obj: { show: boolean; dataobject?: any; tab?: string }) {
      this.modals.editstaff.dataobject = obj.dataobject || null
      this.modals.editstaff.tab = obj.tab || 'basic'
      this.modals.editstaff.show = obj.show
      if (obj.show === false) {
        document.body.classList.remove('modal-open')
      } else {
        document.body.classList.add('modal-open')
      }
    },
    modaleditopeninghours(obj: { show: boolean; dataobject?: any }) {
      this.modals.editopeninghours.data = obj.dataobject || {}
      this.modals.editopeninghours.show = obj.show
      if (obj.show === false) {
        document.body.classList.remove('modal-open')
      } else {
        document.body.classList.add('modal-open')
      }
    },

    /**
     * Open the edit event modal with the provided event data
     */
    openEditEventModal(eventData: any) {
      this.modals.editEventModal.eventData = eventData
      this.modals.editEventModal.isOpen = true
      document.body.classList.add('modal-open')
    },

    /**
     * Close the edit event modal and clear its data
     */
    closeEditEventModal() {
      this.modals.editEventModal.isOpen = false
      this.modals.editEventModal.eventData = null
      this.modals.editEventModal.loading = false
      this.modals.editEventModal.modalContracts = []
      this.modals.editEventModal.modalBookings = []
      document.body.classList.remove('modal-open')
    },

    /**
     * Set contracts data from query worker
     */
    setModalContracts(contracts: any[]) {
      this.modals.editEventModal.modalContracts = contracts
    },

    /**
     * Set bookings data from query worker
     */
    setModalBookings(bookings: any[]) {
      this.modals.editEventModal.modalBookings = bookings
      // Set loading to false when bookings arrive (last piece of data)
      this.modals.editEventModal.loading = false
    },

    /**
     * Set loading state
     */
    setEditEventModalLoading(loading: boolean) {
      this.modals.editEventModal.loading = loading
    },

    /**
     * Schema Update Modal — shown when SchemaGuard detects a mismatch
     */
    showSchemaUpdate(data: { missingTables: string[]; serverVersion: number; localVersion: number }) {
      const s = this.modals.schemaUpdate
      s.missingTables = data.missingTables
      s.serverVersion = data.serverVersion
      s.localVersion = data.localVersion
      s.phase = 'confirm'
      s.steps = { patch: 'pending', recreate: 'pending', sync: 'pending' }
      s.stepMessages = { patch: '', recreate: '', sync: '' }
      s.progress = { tablesLoaded: 0, tablesTotal: 0, records: 0, lastaction: '' }
      s.errorStep = ''
      s.error = ''
      s.show = true
    },
    closeSchemaUpdate() {
      this.modals.schemaUpdate.show = false
    },
    confirmSchemaUpdate() {
      const s = this.modals.schemaUpdate
      // Stays open: the modal now hosts the progress display for the heal.
      s.phase = 'running'
      s.steps = { patch: 'running', recreate: 'pending', sync: 'pending' }
      s.stepMessages = { patch: '', recreate: '', sync: '' }
      s.progress = { tablesLoaded: 0, tablesTotal: 0, records: 0, lastaction: '' }
      s.errorStep = ''
      s.error = ''
      // Dispatch event that tables.ts picks up to send the heal command to worker
      window.dispatchEvent(new CustomEvent('schema_heal_confirmed'))
    },
    /** Worker reported a step transition of the running heal. */
    setSchemaHealStep(step: 'patch' | 'recreate' | 'sync', state: 'pending' | 'running' | 'done', message?: string) {
      const s = this.modals.schemaUpdate
      if (s.phase !== 'running') return
      s.steps[step] = state
      if (message) s.stepMessages[step] = message
      // A later step starting implies the earlier ones finished — the worker
      // can skip a 'done' post when a step fails over into the next one.
      if (step === 'recreate') s.steps.patch = 'done'
      if (step === 'sync') { s.steps.patch = 'done'; s.steps.recreate = 'done' }
    },
    /** Mirrors the worker's `loading` payloads while the resync step runs. */
    setSchemaHealProgress(payload: any) {
      const s = this.modals.schemaUpdate
      if (s.phase !== 'running' || s.steps.sync !== 'running') return
      if (typeof payload?.amountofdatatoload === 'number' && payload.amountofdatatoload > 0) {
        s.progress.tablesTotal = payload.amountofdatatoload
      }
      if (typeof payload?.amountofdataloaded === 'number') {
        s.progress.tablesLoaded = payload.amountofdataloaded
      }
      if (typeof payload?.totalRecords === 'number') {
        s.progress.records = payload.totalRecords
      }
      if (payload?.lastaction) s.progress.lastaction = payload.lastaction
    },
    /** True while a user-confirmed heal is waiting for its resync to finish. */
    isSchemaHealSyncing(): boolean {
      const s = this.modals.schemaUpdate
      return s.show && s.phase === 'running' && s.steps.sync === 'running'
    },
    finishSchemaHeal() {
      const s = this.modals.schemaUpdate
      if (s.phase !== 'running') return
      s.steps.sync = 'done'
      s.progress.lastaction = ''
      s.phase = 'done'
    },
    failSchemaHeal(message: string, step?: 'patch' | 'recreate' | 'sync') {
      const s = this.modals.schemaUpdate
      if (s.phase !== 'running') return
      s.phase = 'error'
      s.error = message || 'Das Update ist fehlgeschlagen.'
      s.errorStep = step || ''
    }
  }
})
